import { useSeasonalComparatorListPreferencesQuery } from 'services/api/Meteorology/Weather/SeasonalComparator';
import { ResponseError } from 'services/api/base';
import { useHandleRequestErrors } from 'utils/hooks';

export default function usePreferences() {
  const { data, error } = useSeasonalComparatorListPreferencesQuery();

  useHandleRequestErrors(error as ResponseError);

  return { preferences: data };
}
